import React, { Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

const SettingsV2TogglePage = React.lazy(() => import('./SettingsV2TogglePage'));

export const settingsV2ToggleRouter: RouteObject = {
  path: 'dev/settings-v2',
  element: (
    <Suspense
      fallback={
        <div className="tw-h-full tw-p-4">
          <Skeleton width="100%" height="100%" />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  ),
  children: [{ index: true, element: <SettingsV2TogglePage /> }],
};
